import Vue from 'vue'
import axios from './utils/axios'
import App from './App.vue'
import router from './router'
import config from "./config/index";
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import 'swiper/css/swiper.css';
import 'animate.css'
import CityPicker from 'vue-city-picker'; 



Vue.use(ElementUI);
Vue.use(NProgress);
Vue.prototype.axios = axios;
Vue.prototype.baseURL = config.baseurl + '/';
Vue.use(CityPicker); // 注册vue-city-picker插件

//ailogo域名
Vue.prototype.baseURLLogo = config.baseurlLogo + '/';

// 动态加载百度统计代码
(function() {
    var _hmt = _hmt || [];
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?9f9b60f596a10c1b494ba79f8f356e69";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
    // 把 _hmt 挂载到 Vue 的原型链上，便于全局调用
    Vue.prototype.$_hmt = _hmt;
})();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

NProgress.configure({
    minimum: 0.1,
    easing: 'ease',
    speed: 800,
    showSpinner: false
});
